import React from "react";
import { useParams } from "react-router-dom";
import { useCityPageQuery } from "../../api/queries/cityQueries";
import { OverFlowBannerSwiper } from "../../components/swiper/OverFlowBannerSwiper";
import ListView from "./components/ListView";
import BreadcrumbNavigation from "../../components/product-detail/BreadcrumbNavigation";

const CityDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: dto } = useCityPageQuery(id ?? "");
  // if (!dto) return null;
  return (
    <div className="relative">
      <BreadcrumbNavigation ls={[dto?.city?.name ?? ""]} />
      <OverFlowBannerSwiper
        ls={dto?.files ?? []}
        onClick={() => {
          if (dto?.city?.bannerUrl) {
            window.open(dto.city.bannerUrl, "_blank");
          }
        }}
      />
      {dto && <ListView dto={dto} />}
    </div>
  );
};

export default CityDetailPage;
